import React, { useState, useEffect } from 'react';
import ActivComponent from '../components/DashBord/ActivComponent';
import AsideComponent from '../components/DashBord/AsideComponent';
import WComeComponent from '../components/DashBord/WComeComponent';
import HeaderComponent from '../components/General/HeaderComponent';
import { getDashboard } from '../services/dashboard';
import calendarService from '../services/calendar';
import UpcomingEventsList from '../components/DashBord/UpcomingEventsList';

const aktifp = '/assets/dashboard/aktifp.svg';
const aktifdark = '/assets/dashboard/aktifdark.svg';
const gorevlerimdark = '/assets/dashboard/gorevlerimdark.svg';
const hesabiydark = '/assets/dashboard/hesabiydark.svg';
const hesapY = '/assets/dashboard/hesapY.svg';
const gorevlerim = '/assets/dashboard/gorevlerim.svg';
const yaklasanE = '/assets/dashboard/yaklasanE.svg';
const yaklasanedark = '/assets/dashboard/yaklasanedark.svg';

export default function Dashboard() {
    const [dashData, setDashData] = useState({
        userInfo: {},
        lastProjects: { lastProjects: [] },
        userNotes: { userNoteCount: 0, info: [] },
        lastCalendar: { lastCalendars: [] }
    });
    const [loading, setLoading] = useState(true);
    const [penaToken, setPenaToken] = useState();
    const [upcomingFromCalendar, setUpcomingFromCalendar] = useState([]);

    useEffect(() => {
        // Token'ı localStorage'dan al - farklı key'leri kontrol et
        const token =
            localStorage.getItem('penatoken') ||
            localStorage.getItem('token') ||
            localStorage.getItem('authToken') ||
            localStorage.getItem('accessToken') ||
            localStorage.getItem('penaToken');
        setPenaToken(token);
    }, []);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                // Dashboard çek
                const data = await getDashboard();
                if (data) {
                    setDashData(data);
                }

                // Takvimden yaklaşanları çek (yeni API > eski API)
                if (penaToken) {
                    try {
                        const upcoming = await calendarService.getUpcomingItems(penaToken);
                        const items = Array.isArray(upcoming?.upcomingItems)
                            ? upcoming.upcomingItems
                            : [];
                        // Sadece takvim etkinliklerini al, ActivComponent'in beklediği şemaya dönüştür
                        const mapped = items
                            .filter(it => it && (it.type === 'calendar_event' || it.type === 'event'))
                            .map(it => ({
                                id: `${it.type}-${it.id}`,
                                c_title: it.title,
                                c_desc: it.description,
                                c_priority: parseInt(it.priority ?? 1),
                                c_start: parseInt(it.start),
                                c_end: parseInt(it.end)
                            }));
                        setUpcomingFromCalendar(mapped);
                    } catch (e) {
                        // Eski API'ye düş
                        try {
                            const legacy = await calendarService.getUpcomingEvents(penaToken);
                            // legacy zaten c_* alanları ile geliyor varsayımıyla direkt kullan
                            setUpcomingFromCalendar(Array.isArray(legacy) ? legacy : []);
                        } catch (_) {
                            // Son çare: tüm takvim öğelerini çekip gelecek olanları listele
                            try {
                                const all = await calendarService.getAllCalendarItems(penaToken);
                                const items = Array.isArray(all?.calendar_items) ? all.calendar_items : [];
                                const now = Date.now();
                                const mapped = items
                                    .filter(it => it && (it.type === 'calendar_event' || it.type === 'event'))
                                    .filter(it => parseInt(it.end) >= now)
                                    .sort((a, b) => parseInt(a.start) - parseInt(b.start))
                                    .map(it => ({
                                        id: `${it.type}-${it.id}`,
                                        c_title: it.title,
                                        c_desc: it.description,
                                        c_priority: parseInt(it.priority ?? 1),
                                        c_start: parseInt(it.start),
                                        c_end: parseInt(it.end)
                                    }));
                                setUpcomingFromCalendar(mapped);
                            } catch (__) {
                                setUpcomingFromCalendar([]);
                            }
                        }
                    }
                }
            } catch (error) {
                // sessiz geç
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [penaToken]);

    if (loading) {
        return (
            <div className="w-full h-screen flex justify-center items-center dark:bg-dark-100">
                <img src="/assets/penalogo.svg" alt="Yükleniyor..." width="200" height="200" className="animate-pulse" />
            </div>
        );
    }

    const { userInfo, lastProjects, userNotes, lastCalendar } = dashData;

    // Backend lastCalendar nesnesini normalize et
    const lastCalendarList = Array.isArray(lastCalendar)
        ? lastCalendar
        : (Array.isArray(lastCalendar?.lastCalendars) ? lastCalendar.lastCalendars : []);

    // Gösterilecek yaklaşanlar: Takvimden gelenler öncelikli; yoksa backend dashboard'tan gelen
    const upcomingList = (Array.isArray(upcomingFromCalendar) && upcomingFromCalendar.length > 0)
        ? upcomingFromCalendar
        : lastCalendarList;

    return (
        <div className="w-full dark:bg-dark-100 bg-stone-100 transition duration-300 flex flex-col lg:mt-0 mt-20">
            <div className="container mx-auto">
                <HeaderComponent title={'Dashboard'} />
                <WComeComponent userstaskCount={userNotes.userNoteCount} userinfo={userInfo} isCheck={true} />

                <div className="flex flex-col lg:flex-row md:mt-8">
                    <div className="lg:basis-3/4 w-full">
                        <ActivComponent
                            title={'Aktif Projeler'}
                            darkImage={aktifdark}
                            lightImage={aktifp}
                            desc={'Proje listeniz boş gözüküyor. Buraya tıklayarak proje oluşturabilirsiniz.'}
                            data={lastProjects.lastProjects}
                            isProject={true}
                        />
                    </div>
                    <div className="lg:basis-1/4 lg:mt-0 my-4 w-full">
                        <AsideComponent
                            titlepos={'top'}
                            title={'Notlarım'}
                            darkImage={gorevlerimdark}
                            lightImage={gorevlerim}
                            desc1={'Not listeniz boş gözüküyor. Buraya tıklayarak bir görev ekleyin.'}
                            tasks={userNotes.info}
                        />
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row items-stretch">
                    <div className="lg:basis-3/4 w-full h-full">
                        <UpcomingEventsList
                            title={'Yaklaşan Etkinlikler'}
                            desc={'Etkinlik listeniz boş görünüyor. Buraya tıklayarak bir etkinlik oluşturabilirsiniz.'}
                            data={upcomingList}
                        />
                    </div>
                    <div className="lg:basis-1/4 lg:mt-0 my-4 w-full h-full max-w-[394px]">
                        <AsideComponent
                            titlepos={'bottom'}
                            title={'Hesabı yükselt'}
                            darkImage={hesabiydark}
                            lightImage={hesapY}
                            desc1={"Premium'a geçerek daha fazla özellik ve iş aracının kilidini açın."}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
